import { ArrowRightIcon } from "@heroicons/react/outline";
import Button from "../library/Button";
import { classNames } from "../library/utils/classNames";

type Callout = {
  title: string;
  description: string;
};

interface FeatureSectionProps {
  title: React.ReactNode;
  description: React.ReactNode;
  callouts: Callout[];
  image: React.ReactNode;
  wide?: boolean;
  learnMore?: React.ReactNode;
}

export const FeatureCard = ({
  title,
  description,
  callouts,
  image,
  learnMore,
  wide,
}: FeatureSectionProps) => {
  return (
    <div
      className={classNames(
        "relative overflow-hidden rounded-[16px] bg-white px-16 shadow-a dark:bg-[#171717] dark:shadow-none md:px-64",
        wide
          ? "col-span-full md:py-48"
          : "col-span-full md:col-span-1 md:py-64 ",
        "py-28"
      )}
    >
      <div className="flex flex-col gap-x-48 md:flex-row">
        <main
          className={classNames(
            wide ? " mr-32 w-full max-w-lg md:w-1/2" : "w-3/5  flex-none"
          )}
        >
          <div className="mb-48">
            <h3 className="mb-16 text-16-24 font-bold text-blue-700 dark:text-white">
              {title}
            </h3>
            <p className="mb-12 text-14-22 text-gray-700 dark:text-gray-500">
              {description}{" "}
            </p>
            {learnMore}
          </div>
          <div
            className={classNames(
              "hidden grid-cols-2 gap-x-48 gap-y-32 md:grid",
              wide ? "grid-cols-2" : "grid-cols-1"
            )}
          >
            {callouts.map((callout: Callout) => (
              <div key={callout.title}>
                <h4 className="mb-6 text-13-16 font-bold text-gray-900 dark:text-gray-400">
                  {callout.title}
                </h4>
                <p className="text-13-20 text-gray-600">
                  {callout.description}
                </p>
              </div>
            ))}
          </div>
        </main>
        <div
          className={classNames(
            "h-[100px] flex-none md:h-full",
            wide ? "md:w-1/2" : ""
          )}
        >
          {image}
        </div>
      </div>
    </div>
  );
};
